import { TStrapiV4ChicletList } from '../../common-types'
import StrapiV4Chiclet from '../../atoms-components/chiclet/StrapiV4Chiclet'
import Carousel from '@/stories/components/Common/Carousel/Carousel'

type TProps = {
  data: TStrapiV4ChicletList
}

const StrapiV4ChicletList = ({ data }: TProps) => {
  return (
    <Carousel autoPlayInterval={3000} className="mt-8 xl:mt-12">
      <ul className="flex flex-row items-center justify-start gap-2">
        {data.chiclets?.map((chiclet, idx) => (
          <StrapiV4Chiclet text={chiclet.text} link={chiclet.link} key={idx} />
        ))}
      </ul>
    </Carousel>
  )
}

export default StrapiV4ChicletList
